<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm">
</app-lfsa-card>

<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Mes Actual'"
          [label]="'Mes Actual *'" [id]="'mesDescripcion'" formControlName="mesDescripcion"
          [control]="formulario.get('mesDescripcion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Año'"
          [label]="'Año *'" [id]="'anio'" formControlName="anio" [control]="formulario.get('anio')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Usuario Actual'"
          [label]="'Usuario Actual *'" [id]="'usuario'" formControlName="usuario"
          [control]="formulario.get('usuario')"></app-lfsa-input>
      </div>
      <!-- <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Canal'" [label]="'Canal *'" [id]="'sueldoVariable'"
          formControlName="sueldoVariable" [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Sueldo Variable'" [label]="'Sueldo Variable *'" [id]="'sueldoVariable'"
          formControlName="sueldoVariable" [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div> -->
    </div>
    <!-- <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario> -->
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="detalleComosiones" [titulo]="'Detalle de Avance'">
</app-lfsa-card>

<ng-template #detalleComosiones>
  <div class="form-group">
    VARIABLES FIJAS
    <hr>
    <style>
      .formatList {
        display: flex;
        justify-content: space-between;
      }
    </style>
    <div class="row">
      <div class="form-group col-12 col-md-4" *ngFor="let variable of listVariables">
        <div class="card border-success">
          <div class="row card-body">
            <div>Nombre de Variable (Pendiente)</div>
            <hr class="mt-3">
            <div class="formatList">
              <div>PRESUPUESTO:</div>
              <div>${{ variable.valorMeta }}</div>
            </div>
            <div class="formatList">
              <div>AVANCE PORCENTUAL:</div>
              <div>{{ variable.cumplimiento }} %</div>
            </div>
            <div class="formatList">
              <div>AVANCE EN DOLARES:</div>
              <div>${{ variable.valorVenta }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group mt-5">
      INCENTIVO
      <hr>
      <div class="row">
        <div class="form-group col-12 col-md-4" *ngFor="let incentivo of listIncentivos">
          <div class="card border-success">
            <div class="row card-body">
              <div>Nombre de incentivo (Pendiente)</div>
              <hr class="mt-3">
              <div class="formatList">
                <div>PRESUPUESTO:</div>
                <div>${{ incentivo.valorMeta }}</div>
              </div>
              <div class="formatList">
                <div>AVANCE PORCENTUAL:</div>
                <div>{{ incentivo.cumplimiento }} %</div>
              </div>
              <div class="formatList">
                <div>AVANCE EN DOLARES:</div>
                <div>${{ incentivo.valorVenta }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>